<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <ProductionStrategy
      :companies="[company]"
      :registry-devices="registryDevices"
    />
  </div>
</template>

<script setup lang="ts">
import ProductionStrategy from "@/dashboard/production_strategy/ProductionStrategy.vue";
import type { Company, RegistryDevice } from "@/types";

defineProps<{
  company: Company;
  registryDevices: RegistryDevice[];
}>();
</script>
